import { BREAKPOINTS } from '@libs/common-next';

export const calculateBreakpointConfiguration = (numOfTiles: number) => {
    return {
        0: {
            spaceBetween: numOfTiles < 2.5 ? 0 : 8,
            slidesPerView: 2.5,
        },
        [BREAKPOINTS.sm2]: {
            spaceBetween: numOfTiles < 3.5 ? 0 : 32,
            slidesPerView: 3.5,
        },
        [BREAKPOINTS.lg]: {
            spaceBetween: numOfTiles < 6 ? 0 : 32,
            slidesPerView: 6,
            slidesPerGroup: 6,
        },
    };
};
